import EntityManager from '@/pages/admin/components/EntityManager';
import { leaderFields, leaderColumns } from '@/pages/admin/entityConfigs';

export default function LeadersPage() {
  return (
    <EntityManager
      table="leaders"
      fields={leaderFields}
      columns={leaderColumns}
      orderBy="sort_order"
      ascending
      searchKeys={['name', 'title']}
      addLabel="Add Leader"
    />
  );
}